import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/3ed0734e/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const MdxIcon = makeShortcode("MdxIcon");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "rapidly-build-beautiful-and-accessible-experiences-the-carbon-kit-contains-all-resources-you-need-to-get-started"
    }}>{`Rapidly build beautiful and accessible experiences. The Carbon kit contains all resources you need to get started.`}</h3>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Get the kit</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Start designing</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Anatomy</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Info</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "get-the-kit"
    }}>{`Get the kit`}</h2>
    <h4 {...{
      "id": "1-install-sketch"
    }}>{`1. `}<strong parentName="h4">{`Install Sketch`}</strong>{`.`}</h4>
    <p>{`To design with Carbon you must have the `}<strong parentName="p">{`most recent version`}</strong>{` of `}<a parentName="p" {...{
        "href": "https://www.sketchapp.com/"
      }}>{`Sketch`}</a>{` installed.`}</p>
    <h4 {...{
      "id": "2-choose-a-theme"
    }}>{`2. `}<strong parentName="h4">{`Choose a theme`}</strong>{`.`}</h4>
    <p>{`There are `}<a parentName="p" {...{
        "href": "/guidelines/color/overview#themes"
      }}>{`four Carbon themes`}</a>{`, two light (White and Gray 10) and two dark (Gray 90 and Gray 100). Each theme lives in its own Sketch library. You can subscribe to as many libraries as you’d like.`}</p>
    <Row className="resource-card-group" mdxType="Row">
  <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
    <ResourceCard subTitle="Get the White theme" href="sketch://add-library/cloud/JaVzz" mdxType="ResourceCard">
      <MdxIcon name="sketch" mdxType="MdxIcon" />
    </ResourceCard>
  </Column>
  <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
    <ResourceCard subTitle="Get the Gray 10 theme" href="sketch://add-library/cloud/Onwv2" mdxType="ResourceCard">
      <MdxIcon name="sketch" mdxType="MdxIcon" />
    </ResourceCard>
  </Column>
  <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
    <ResourceCard subTitle="Get the Gray 90 theme" href="sketch://add-library/cloud/eo37p" mdxType="ResourceCard">
      <MdxIcon name="sketch" mdxType="MdxIcon" />
    </ResourceCard>
  </Column>
  <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
    <ResourceCard subTitle="Get the Gray 100 theme" href="sketch://add-library/cloud/d13Ll" mdxType="ResourceCard">
      <MdxIcon name="sketch" mdxType="MdxIcon" />
    </ResourceCard>
  </Column>
    </Row>
    <br />
    <br />
    <h4 {...{
      "id": "3-bring-in-additional-colors-and-icons"
    }}>{`3. `}<strong parentName="h4">{`Bring in additional colors and icons`}</strong>{`.`}</h4>
    <p>{`The full icon library and additional color collections live in the IBM Design Language library.`}</p>
    <Row className="resource-card-group" mdxType="Row">
  <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
    <ResourceCard subTitle="Get the IBM Design Language library" href="sketch://add-library/cloud/75VZZ" mdxType="ResourceCard">
      <MdxIcon name="sketch" mdxType="MdxIcon" />
    </ResourceCard>
  </Column>
    </Row>
    <br />
    <br />
    <h4 {...{
      "id": "4-download-the-grid-templates"
    }}>{`4. `}<strong parentName="h4">{`Download the grid templates`}</strong>{`.`}</h4>
    <p>{`Visit the `}<a parentName="p" {...{
        "href": "https://sketch.cloud/s/ngV7z"
      }}>{`Sketch library`}</a>{` page and choose `}<inlineCode parentName="p">{`Download Document`}</inlineCode>{` from the right-side panel.`}</p>
    <Row className="resource-card-group" mdxType="Row">
  <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
    <ResourceCard subTitle="Download the IBM Grid template" href="https://sketch.cloud/s/ngV7z" mdxType="ResourceCard">
      <MdxIcon name="sketch" mdxType="MdxIcon" />
    </ResourceCard>
  </Column>
  <Column colLg={4} colMd={4} noGutterSm mdxType="Column">
    <ResourceCard subTitle="Download the UI Shell template" href="https://sketch.cloud/s/EjVmA" mdxType="ResourceCard">
      <MdxIcon name="sketch" mdxType="MdxIcon" />
    </ResourceCard>
  </Column>
    </Row>
    <br />
    <br />
    <p>{`Open the file in Sketch. Navigate to `}<inlineCode parentName="p">{`File → Save as Template`}</inlineCode>{`. You can now access the saved grid template at `}<inlineCode parentName="p">{`File → New file from Template`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "start-designing"
    }}>{`Start designing`}</h2>
    <p>{`To get started with Carbon, familiarize yourself with the contents of each library.`}</p>
    <h4 {...{
      "id": "start-with-the-grid"
    }}><strong parentName="h4">{`Start with the grid`}</strong>{`.`}</h4>
    <p>{`At the top of your screen, navigate to `}<inlineCode parentName="p">{`File → New file from Template`}</inlineCode>{` and select your grid template. You’ll always be able to find the template here.`}</p>
    <h4 {...{
      "id": "icons-and-color-swatches"
    }}><strong parentName="h4">{`Icons and color swatches`}</strong>{`.`}</h4>
    <p>{`Symbols from both the IBM Design Language library and the Carbon library are accessible from any Sketch document. Navigate to `}<inlineCode parentName="p">{`Insert → Symbols → Carbon Design System`}</inlineCode>{` or `}<inlineCode parentName="p">{`IBM Design Language`}</inlineCode>{`.`}</p>
    <h4 {...{
      "id": "youre-all-set"
    }}><strong parentName="h4">{`You’re all set`}</strong>{`.`}</h4>
    <p>{`Refer to the content below for a more detailed breakdown of the kit, or head to Sketch to begin designing.`}</p>
    <h2 {...{
      "id": "anatomy"
    }}>{`Anatomy`}</h2>
    <p>{`See the `}<a parentName="p" {...{
        "href": "https://sketch.cloud/s/JaVzz/"
      }}>{`Sketch library`}</a>{` page for an overview of the kit.`}</p>
    <AnchorLinks small mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Grid</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Symbols</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Text styles</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Layer styles</AnchorLink>
    </AnchorLinks>
    <h3 {...{
      "id": "grid"
    }}>{`Grid`}</h3>
    <p>{`The IBM 2x Grid is the framework for laying out all visual elements in Carbon.`}</p>
    <img {...{
      "src": "/78f2bcb634d36680d173463377316538/grid-2.gif",
      "alt": "2x Grid overview"
    }}></img>
    <Caption mdxType="Caption">2x Grid overview</Caption>
    <p>{`All designs should start with the 2x Grid template. Once you have `}<a parentName="p" {...{
        "href": "#get-the-kit"
      }}>{`saved the grid`}</a>{` as a template, navigate to `}<inlineCode parentName="p">{`File → New file from Template`}</inlineCode>{` and select the grid template.`}</p>
    <p>{`See our `}<a parentName="p" {...{
        "href": "/guidelines/2x-grid/basics/"
      }}>{`layout guidelines`}</a>{` for a more detailed walkthrough of the 2x Grid.`}</p>
    <h4 {...{
      "id": "structure"
    }}>{`Structure`}</h4>
    <p>{`The grid template includes templates for all breakpoints along with the necessary formulas to design for custom screen sizes.`}</p>
    <p>{`To toggle the grid on and off, use `}<inlineCode parentName="p">{`Control+G`}</inlineCode>{`. To toggle the layout guide, use `}<inlineCode parentName="p">{`Control+L`}</inlineCode>{`.`}</p>
    <h3 {...{
      "id": "symbols"
    }}>{`Symbols`}</h3>
    <p>{`Carbon `}<a parentName="p" {...{
        "href": "/components/overview"
      }}>{`components`}</a>{`, `}<a parentName="p" {...{
        "href": "/contributing/add-ons"
      }}>{`add-ons`}</a>{`, and `}<a parentName="p" {...{
        "href": "/guidelines/icons/library"
      }}>{`icons`}</a>{` live in the design kit as Sketch `}<em parentName="p">{`symbols`}</em>{`.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "63.235294117647065%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsSAAALEgHS3X78AAABkUlEQVQoz5WS207cMBCGef+Haa+5601bCQnogcKyOdhxfIjtJI6d425OnRjKrgoq6q/JaGz9nzTjycW6rvOyTvMyzuth8sU0Q4ZLH1uxrG8E6AK+lNH7MP4R8K+/WCJ0ROUes0dEdnFyH6IAM8wVREwzX0hEM0RF0w0bLKVglBJCdo8ByzSXOkk55yyTWZZxyFJJpSQIoxghRAlKk6ht2w1u267remNKFMdVZSpTmrIYp2l9pbqurXX9MLi6PhwOG9w0Te0sFcWnb+w6yG8ie7U3zpq+tcehW5blBDcN48Jaa4wZhuEFdjovb+/C6+8PEZF7oj9+ph++iMvbHAbJi7zr+63HriMpLcuyqqoT7JyDtsNNgdJKa323Qz93OEqyfRCFUWSqCpzQalEU1usEw8FtspMfFTIlmKdJoaTxbrDC/fF4BJOf/A3YvcAJCGNoYTp7OYCfnP+C4akpZYJzrdQ4jv8HQyYYC8Fhu+/AvdfgBVbYDWT4bba2lQRg9oJ7MDzNDPl5z+da/ghK7/9b5+bfUgDheIkM0/cAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Carbon symbol menu navigation",
        "title": "Carbon symbol menu navigation",
        "src": "/static/d9fd6a26f1d812b3ea06faf9b500668b/fb070/carbon-kit.png",
        "srcSet": ["/static/d9fd6a26f1d812b3ea06faf9b500668b/d6747/carbon-kit.png 288w", "/static/d9fd6a26f1d812b3ea06faf9b500668b/09548/carbon-kit.png 576w", "/static/d9fd6a26f1d812b3ea06faf9b500668b/fb070/carbon-kit.png 1152w", "/static/d9fd6a26f1d812b3ea06faf9b500668b/fb104/carbon-kit.png 1728w", "/static/d9fd6a26f1d812b3ea06faf9b500668b/902fb/carbon-kit.png 2304w", "/static/d9fd6a26f1d812b3ea06faf9b500668b/292c2/carbon-kit.png 2720w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h4 {...{
      "id": "library-menu-navigation"
    }}>{`Library menu navigation`}</h4>
    <p>{`There are two kinds of symbols — library symbols and document symbols. Library symbols are available in any Sketch document, while document symbols are specific to the document in which they are found.`}</p>
    <p>{`From the `}<inlineCode parentName="p">{`Insert`}</inlineCode>{` menu, select `}<inlineCode parentName="p">{`Symbols → Carbon Design System`}</inlineCode>{` to add symbols onto your page.`}</p>
    <p>{`Carbon symbols are built to be flexible, and designers should not detach symbols from the library. Once a symbol is detached, you will no longer receive updates as they are released.`}</p>
    <h4 {...{
      "id": "structure-1"
    }}>{`Structure`}</h4>
    <p>{`Symbols are organized by component; after selecting a component, you’ll see the variations and states of that component.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`To add the whole component, select the desired variant and place it on your artboard.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`For even more configurablility, use the individual building blocks found under the `}<inlineCode parentName="p">{`Items`}</inlineCode>{` folder within the symbol. Be sure your custom design adheres to our `}<a parentName="p" {...{
            "href": "/guidelines/accessibility/overview"
          }}>{`design guidelines`}</a>{`.`}</p>
      </li>
    </ul>
    <h3 {...{
      "id": "text-styles"
    }}>{`Text styles`}</h3>
    <p>{`Text styles are based on typography rules defined by the `}<a parentName="p" {...{
        "href": "https://www.ibm.com/design/language/elements/type-basics"
      }}>{`IBM Design Language`}</a>{`.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "63.235294117647065%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACMElEQVQ4y61T227aQBDNZ7V/0UrtD+V/IlUNq6itRPoQ0iZpBZhLMARszCU2Zn1dY7DXezo2BBUpj1npeOyZ2bNzZtZnAM7efN0+3J3/bmn1+p+nyy83I9YdW6ypm+y+M2R37Uf2q9VjN3819tDVmTY0mTaaspZusA5ZbTittfVxTdMn35uPk3cVoTU1rqXMsVo5WCyXiMQGcZLCC0JEUYBYxIQQgqxIBBKCEAIu5TuOA+7a2IgApml9qgjDMGIkHZx7u9HYkNwP5Zr70nG5lLKQFHoVsRAyDMM8TbdZut3Cdd0PFaHv+1dFUWC9Xsvx05OaWZZyHFvxtauAnACCOgBHxHGsFoulItIiTdOy2o97wiC4KnOeV55stCZoNEfoTly0x1z1Zin6iwxDRyrdLjB4zhFQK7ZUkUgSWNZMcc6L8nu1Wp0S2q4n77sWmoM5hrMA2sRX1/1Efets1EVjri5un/H1gaOtdWGYU8SxAKlTQRCcEpKjkhxFoRQ0BFXk/ynbr5mhY2EOkfgObNuB5/vYbGh4JDuKooqQWnZKSL2QYRSBJlGRKGpZQZySHoZhYj6fl41HcYhnWVbuORJS7EjIDsEdBaXcM0oirFC+6/pATk1DepxLyq18pS2nTHuyhPp5nDI5f5Yn5nleVfXaounDNCbIdtsTf6nsRRFJ/vxybc7phDrhklBWyyiJ0QFH2+/1mD7os+VizkgeIyJW5nqex2h/jewP27bfn731v/wPB3MISRwzzW8AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Text styles navigation",
        "title": "Text styles navigation",
        "src": "/static/a7b10d7946cfebaa49024c6c2b6c5bfd/fb070/text-styles-1.png",
        "srcSet": ["/static/a7b10d7946cfebaa49024c6c2b6c5bfd/d6747/text-styles-1.png 288w", "/static/a7b10d7946cfebaa49024c6c2b6c5bfd/09548/text-styles-1.png 576w", "/static/a7b10d7946cfebaa49024c6c2b6c5bfd/fb070/text-styles-1.png 1152w", "/static/a7b10d7946cfebaa49024c6c2b6c5bfd/fb104/text-styles-1.png 1728w", "/static/a7b10d7946cfebaa49024c6c2b6c5bfd/902fb/text-styles-1.png 2304w", "/static/a7b10d7946cfebaa49024c6c2b6c5bfd/292c2/text-styles-1.png 2720w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h4 {...{
      "id": "library-menu-navigation-1"
    }}>{`Library menu navigation`}</h4>
    <p>{`From the main menu select `}<inlineCode parentName="p">{`Insert → Text Styles → Carbon Design System`}</inlineCode>{` to insert a Carbon type token text style.`}</p>
    <p>{`Text styles within components are carefully considered. We do not recommend detaching the symbol to change default styles.`}</p>
    <h4 {...{
      "id": "structure-2"
    }}>{`Structure`}</h4>
    <p>{`Carbon text styles in Sketch are organized similarly to symbols.`}</p>
    <ul>
      <li parentName="ul">{`The first text style level displays `}<a parentName="li" {...{
          "href": "/guidelines/themes"
        }}>{`theme options`}</a>{` (i.e., white theme).`}</li>
      <li parentName="ul">{`The second level shows the `}<a parentName="li" {...{
          "href": "/guidelines/typography/overview"
        }}>{`Carbon type`}</a>{` tokens (i.e., body-long-01).`}</li>
      <li parentName="ul">{`The third level selects the type color, which is labeled with a `}<a parentName="li" {...{
          "href": "/guidelines/color/overview"
        }}>{`Carbon color`}</a>{` token name.`}</li>
    </ul>
    <h3 {...{
      "id": "layer-styles"
    }}>{`Layer styles`}</h3>
    <p>{`Layer styles are color selections for any shape in Sketch.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "78.125%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsSAAALEgHS3X78AAACPklEQVQ4y62SzZKaQBSFeaG8wyzyjLOYRTapPEKqrDCZpJJUNslorIxBqRFUfhoQkF8HpOmT24xa6mhWaerUbZruj3P7XkX538NxHNUmzWYzdTqdkoxtnKrz+Vy1LEtdLBbdXK4ZhrHfK6Njmaq9MFTLtm9Ho9ErxfM82IyBFkCHQIe7KGXTGgG7KNelCAJd1/d7LHNM0mifjUH//rXSNA2XauXTtlyIlgOgKPjpAK1Vdc0fp1O+Wq14lmU8SbImzXKKiWCMXSk4GbwV0AyGuuE4N+insB0GgoGgyNJUUBRxHMtsrhRygp06IG9hWD42Tdu9v/zOCeiA7h7kCkVRCCn5A7qaY4e7Q4fvxwIaAjoswHg8QRTFKMqSYLkoyzXcw5R3MBlbSlvg0mixXAYwHnWEAcO6SEVVZlLwmHvO4bMT8A3ZqSj1BlXdYBkXcOMa5nKDgebj208d938sDHUmHsxYaIsVhg+Tl0Cqcje3Jn2MvvdQrCtYLETv0wBv7xxc32UUA7z56OFGdXFz64vrD4F498XH5x/6OeBzsv3hBO97X1HkKQKfilRXXbpoN3iS6QUhwjglJVTlRORpDNe5UBTOGzxVNdKsQBxFdGdL1HW9b6s8L2CaJnzfo7ZJZIVFkqTU+NZlh7bL8Ov3QwfzyeEOKPuQ2oQqHCEMQ9mLHTBN0/Ntswc6NrSxRg6y7uApUPZdnucydkA5p968lDKnYpRgPrvoUDraSmyh/wDKQ3R/Sy9AGIVHd3gIlJBT4F9yEmdhkYQeoAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Layer styles navigation example",
        "title": "Layer styles navigation example",
        "src": "/static/6aead45d8d7dfd9aab15360eb947b199/fb070/layer-style-1.png",
        "srcSet": ["/static/6aead45d8d7dfd9aab15360eb947b199/d6747/layer-style-1.png 288w", "/static/6aead45d8d7dfd9aab15360eb947b199/09548/layer-style-1.png 576w", "/static/6aead45d8d7dfd9aab15360eb947b199/fb070/layer-style-1.png 1152w", "/static/6aead45d8d7dfd9aab15360eb947b199/c3e47/layer-style-1.png 1472w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <Caption mdxType="Caption">Use predetermined overrides when possible</Caption>
    <h4 {...{
      "id": "library-menu-navigation-2"
    }}>{`Library menu navigation`}</h4>
    <p><a parentName="p" {...{
        "href": "/guidelines/color/overview"
      }}>{`Color`}</a>{` in Carbon is carefully considered, and we discourage custom layer styles.`}</p>
    <p>{`The first layer is the theme selection (i.e., 01 White theme). The second layer is core Carbon color tokens (i.e., field-01) for the selected them. The interaction state tokens are nested in a third layer under “state”.`}</p>
    <h2 {...{
      "id": "info"
    }}>{`Info`}</h2>
    <p>{`If you’re brand new to Sketch, they offer some great `}<a parentName="p" {...{
        "href": "https://www.sketchapp.com/docs/"
      }}>{`tutorials and help docs`}</a>{`.`}</p>
    <h3 {...{
      "id": "updates"
    }}>{`Updates`}</h3>
    <p>{`We make small adjustments and bug fixes to the kit on a regular basis. When we make a change to any of the libraries, you will be notified via a red pop-up in the top right corner of the Sketch window.`}</p>
    <p>{`The updates are opt-in, however we recommend you keep your kit as up to date as possible. Once a change is accepted, you will not be able to revert to the previous version.`}</p>
    <h3 {...{
      "id": "migration"
    }}>{`Migration`}</h3>
    <p>{`If you’re using an older version of Carbon, check out the v10 `}<a parentName="p" {...{
        "href": "/updates/v10-migration/designers"
      }}>{`migration docs`}</a>{` when you’re ready to make the switch.`}</p>
    <h3 {...{
      "id": "support"
    }}>{`Support`}</h3>
    <p>{`Can’t find an answer to your question? Open up an issue on `}<a parentName="p" {...{
        "href": "https://github.com/carbon-design-system/carbon/issues/new/choose"
      }}>{`GitHub`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      